module.exports = __webpack_public_path__ + "static/images/components/RewardMoney/images/industrial_resources-large.d636d698.png";


//////////////////
// WEBPACK FOOTER
// ./components/RewardMoney/images/industrial_resources-large.png
// module id = 2674
// module chunks = 11